// extracted by mini-css-extract-plugin
export default {"item":"lzOpnJit","selected":"y8q2LxXn","base":"SzaVrnV_","danger":"Eq1PCAc5","cancel":"pMsa6SJn","primary":"F1Gmc4YO","action":"tCpvjCaC"};